import React, {useEffect, useState} from 'react'
import {useParams} from "react-router-dom";
import HttpRequest from "../../Http/HttpRequest";
import CustomSelect from "./CustomSelect";
import Notify from "../../Notify/Notify";

export default function UserProfileCustomSelect({setValue, onlyId}) {

    const [isLoading, setIsLoading] = useState(true);
    const [userData, setUserData] = useState({});
    let {id} = useParams();

    useEffect(() => {

        async function getAllUsers() {
            try {
                const [allProfiles, userProfiles] = await Promise.all([
                    HttpRequest.get(`${process.env.REACT_APP_NODE_SERVICE}auth/users/current-profiles`),
                    HttpRequest.get(`${process.env.REACT_APP_NODE_SERVICE}auth/users/${id}/profiles`)
                ]);
                setUserData({allProfiles: allProfiles.profiles, userProfiles: userProfiles.profiles});
            } catch (error) {
                Notify.error('Erro ao buscar usuários', error)
            } finally {
                setIsLoading(false);
            }
        }

        setIsLoading(true);
        getAllUsers()
    }, [id]);


    return (<CustomSelect setValue={setValue} isLoading={isLoading} availables={userData.allProfiles}
                          selecteds={userData.userProfiles}/>)
}
